<h1 mat-dialog-title>Einfügen hinter bestehender Buchungsposition</h1>
<mat-form-field appearance="outline" class="w-full">
    <mat-label>Wähle eine Position</mat-label>
    <mat-select [(ngModel)]="selectedIndex">
        <mat-option>
            <ngx-mat-select-search [(ngModel)]="searchString" placeholderLabel="Suche nach Positionen" noEntriesFoundLabel="Keine Positionen gefunden">
                <fa-icon ngxMatSelectSearchClear icon="times"></fa-icon>
            </ngx-mat-select-search>
        </mat-option>
        <!-- options not matching the search are kept hidden while selected, so the select still shows their label -->
        <mat-option *ngIf="(!allowOnlyLastPositionInGroup || data.length === 0) && (selectedIndex === -1 || matchesSearch(firstPositionLabel))" [value]="-1" [style.display]="matchesSearch(firstPositionLabel) ? null : 'none'">{{ firstPositionLabel }}</mat-option>
        <ng-container *ngFor="let item of data; let i = index">
            <mat-option *ngIf="item.visible && (selectedIndex === i || matchesSearch(item.label, item.hint))" [value]="i" [style.display]="matchesSearch(item.label, item.hint) ? null : 'none'">
                {{ item.label }} <i *ngIf="item.hint">- ({{ item.hint }})</i>
            </mat-option>
        </ng-container>
    </mat-select>
</mat-form-field>
<mat-dialog-actions align="end" class="gap-4">
    <button app-button [mat-dialog-close]="null" Inverted Color="cancel">abbrechen</button>
    <button app-button [Disabled]="this.selectedIndex === null" [mat-dialog-close]="this.selectedIndex + 1" Color="green">hinzufügen</button>
</mat-dialog-actions>
